import { render, staticRenderFns } from "./ClubStatistics.vue?vue&type=template&id=49a7a079&scoped=true"
import script from "./ClubStatistics.vue?vue&type=script&lang=js"
export * from "./ClubStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a7a079",
  null
  
)

export default component.exports